export const banner = `
██╗░░██╗██████╗░██╗░██████╗██╗░░██╗
██║░██╔╝██╔══██╗██║██╔════╝██║░░██║
█████═╝░██████╔╝██║╚█████╗░███████║
██╔═██╗░██╔══██╗██║░╚═══██╗██╔══██║
██║░╚██╗██║░░██║██║██████╔╝██║░░██║
╚═╝░░╚═╝╚═╝░░╚═╝╚═╝╚═════╝░╚═╝░░╚═╝ 
`;

export const allCommands = [
  "whois",
  "whoami",
  "social",
  "email",
  "ls",
  "banner",
  "gui",
  "projects",
  "date",
  "help",
  "repo",
  "projects go 1",
  "projects go 2",
  "projects go 3",
  "projects go 4",
];

export const projectsMap = [
  {
    id: "1",
    title: "Personal Portfolio Website",
    description:
      "This website is built using ReactJS and Typescript. It is a single page application with a terminal like interface. It is hosted on netlify and the source code is available on github.",
  },
  {
    id: "2",
    title: "Octoprofiler",
    description:
      "Octoprofiler is a website that helps you to find the most active users on github. It is built using ReactJS and Typescript. It is hosted on vercel and the source code is available on github.",
  },
  {
    id: "3",
    title: "Talk to terminal",
    description:
      "Talk to terminal is a command-line tool that helps you to chat using your inbuilt terminal sessions. It is built using Python, sockets and threads.",
  },
  {
    id: "4",
    title: "Farmgistics",
    description:
      "Farmgistcs is a website that helps farmers to sells their crops directly to wholesellers. It is built using ReactJS, TypeScript, ExpressJS and MongoDB.",
  },
];
